<template>
    <div class="version2-top-block">
        <leftBlock></leftBlock>
        <middleBlock></middleBlock>
        <rightBlock></rightBlock>
    </div>
</template>

<script>
import leftBlock from './leftBlock'
import middleBlock from './middleBlock'
import rightBlock from './rightBlock'

export default {
  data() {
    return {

    }
  },
  components: {
    leftBlock,
    middleBlock,
    rightBlock
  }
}
</script>
